// File: HelpCommunications.jsx
import React from "react";
import "./Help.css";
import { FaEnvelopeOpenText, FaShieldAlt, FaExclamationTriangle } from "react-icons/fa";

const HelpCommunications = () => {
  return (
    <section className="helpSection p-3">
      <div className="container-xl">
        <div className="helpHeader mb-4">
          <h2 className="fw-bold text-dark">Communications</h2>
          <p className="text-muted">
            Learn how YOVHO keeps your conversations safe and private when you message properties.
          </p>
        </div>

        <div className="helpContent">
          {/* 1 */}
          <div className="helpItem">
            <div className="helpIcon">
              <FaEnvelopeOpenText />
            </div>
            <div className="helpText">
              <h5>How does YOVHO handle guest-property communication?</h5>
              <p>
                For every confirmed booking, YOVHO.com creates a secure and unique email address so guests
                and properties can communicate safely without sharing personal contact details.
              </p>
              <p>
                Any message you send through this address — including links or attachments (up to 15 MB) — 
                is automatically forwarded to the property. This keeps all exchanges simple and private.
              </p>
            </div>
          </div>

          {/* 2 */}
          <div className="helpItem">
            <div className="helpIcon">
              <FaShieldAlt />
            </div>
            <div className="helpText">
              <h5>How does YOVHO protect my messages?</h5>
              <p>
                To protect you from scams or spam, our system automatically checks messages for suspicious 
                or unsafe content and blocks risky file types like <code>.zip</code> or <code>.exe</code>. 
                All communication is safely stored for a limited time and may only be reviewed when necessary — 
                such as for resolving issues, ensuring safety, or meeting legal requirements.
              </p>
            </div>
          </div>

          {/* 3 */}
          <div className="helpItem">
            <div className="helpIcon">
              <FaExclamationTriangle />
            </div>
            <div className="helpText">
              <h5>What should I do if I receive a suspicious message?</h5>
              <p>
                If you ever receive a message that seems unrelated to your stay or appears suspicious, 
                you can report it directly using the link in the email. Our security team will review it promptly 
                and take appropriate action to protect your account and personal data.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HelpCommunications;
